export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6592.f36a022a.jpg";